import React from 'react';
import PropTypes from 'prop-types';
import UserIcon from '../../Visuals/Icons/UserIcon.icon';
import ManagerEmployeeInput from '../../Components/UserForm/ManagerEmployeeInputs.component';

const CompanyManagerSignUp = ({ user, setUser }) => {
  return (
    <>
      <h3 style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap' }}>
        Company Manager <UserIcon />
        <span>This is your account to login and manage the company</span>
      </h3>
      {/* First Name */}
      <ManagerEmployeeInput
        user={user}
        setUser={setUser}
        type="Manager"
        setType={null}
        showType={false}
      />{' '}
    </>
  );
};
CompanyManagerSignUp.propTypes = {
  user: PropTypes.shape({
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    email: PropTypes.string,
    phoneNumber: PropTypes.string,
    password: PropTypes.string,
  }),
  setUser: PropTypes.func,
};

export default CompanyManagerSignUp;
